const PASSKEY_HINT_STORAGE_KEY = 'boltai.auth.has-passkey';
const PASSKEY_HINT_EVENT = 'boltai.auth.passkey-hint-changed';

export function isPasskeyClientSupported() {
  return (
    typeof window !== 'undefined' &&
    typeof window.PublicKeyCredential !== 'undefined'
  );
}

export function getPasskeyClientHint() {
  if (!isPasskeyClientSupported()) {
    return false;
  }

  try {
    return window.localStorage.getItem(PASSKEY_HINT_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function setPasskeyClientHint(hasPasskey: boolean) {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    if (hasPasskey) {
      window.localStorage.setItem(PASSKEY_HINT_STORAGE_KEY, 'true');
    } else {
      window.localStorage.removeItem(PASSKEY_HINT_STORAGE_KEY);
    }

    window.dispatchEvent(
      new CustomEvent(PASSKEY_HINT_EVENT, {
        detail: { hasPasskey },
      }),
    );
  } catch {
    // localStorage can be unavailable in private or restricted browser modes.
  }
}

export function addPasskeyClientHintListener(listener: () => void) {
  if (typeof window === 'undefined') {
    return () => undefined;
  }

  window.addEventListener(PASSKEY_HINT_EVENT, listener);
  window.addEventListener('storage', listener);

  return () => {
    window.removeEventListener(PASSKEY_HINT_EVENT, listener);
    window.removeEventListener('storage', listener);
  };
}
